var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"mb-2 text-center",attrs:{"sub-title":_vm.nombre,"img-src":_vm.laFoto,"img-alt":"foto","img-top":""}},[_c('b-card-text',[_vm._v(" "+_vm._s(_vm.puesto)+" ")]),_c('hr'),_c('b-card-text',[_c('small',[_vm._v(_vm._s(_vm.telefono))]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.email))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }